import TeRitoAdapter from './base';

export default class Connection extends TeRitoAdapter {
  modelNamePlural = 'connections';
}
